module.exports = __webpack_public_path__ + "img/img9.a6cb7ded.png";